import { Navigate } from "react-router-dom";

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const user = useUser();

  if (!user || user === undefined) {
    return <Navigate to="/signIn" replace />;
  }

  return children;
}

const useUser = () :string | null => {
    return localStorage.getItem('token') 
}